
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.588 10.034c-.23-.795-.906-1.422-1.763-1.636C21.26 8 15 8 15 8s-6.26 0-7.825.382c-.84.214-1.533.857-1.763 1.652C5 11.487 5 14.5 5 14.5s0 3.028.412 4.466c.23.795.906 1.422 1.763 1.636C8.756 21 15 21 15 21s6.26 0 7.825-.383c.857-.213 1.533-.84 1.763-1.636.412-1.453.412-4.466.412-4.466s.016-3.028-.412-4.48zm-11.581 7.25v-5.567l5.205 2.783-5.205 2.784z","fill":"#fff"}})])
          )
        }
      }
    